import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import isUndefined from 'lodash/isUndefined'
import { useTimeout } from 'react-nb-hooks'
import { translate } from 'loankeeper-common/helpers'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'

import { useLivedata } from 'shared'
import LKModal from 'shared/LKModal'
import { isSTKExpired, setSTKExpired } from '../../store/auth'

const MODAL_NAME = 'userStkExpired'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

const STKExpired = () => {
  const dispatch = useDispatch()

  const { Locked } = useLivedata('OpenDayStatus.Locked as Locked')

  const handleLogout = React.useCallback(() => {
    dispatch(setSTKExpired(false))
  }, [dispatch])

  useTimeout(handleLogout, 60000)

  return (
    <LKModal
      name={MODAL_NAME}
      icon="alert"
      onClose={handleLogout}
      heading={translate('LKMESSAGE-MSG_WARNING')}
      size="xxs"
      footer={
        <LKModal.Footer>
          <LKBaseButton.Okay onClick={handleLogout} />
        </LKModal.Footer>
      }
    >
      <Wrapper>
        {!isUndefined(Locked) && Locked === 1 ? translate('LKMESSAGE-ERR_EOD_RUNNING') : 'STK-ს ვადა გაუვიდა'}
      </Wrapper>
    </LKModal>
  )
}

export const withSTKExpirationGuard = (Component) => (props) => {
  const stkExpired = useSelector(isSTKExpired)

  if (stkExpired) {
    return <STKExpired />
  }

  return <Component {...props} />
}
